import React from 'react';

import { useFeatureFlag } from '@order/LaunchDarkly';

import { NotFoundView, SignedOutView } from '../../components';
import { useIsLoggedIn } from '../../context/AuthMachine';
import { SweetpassCheckout } from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const SweetpassCheckoutScreen = () => {
  const isSweetpassEnabled = useFeatureFlag('CELS-6211-sweetpass-enabled');
  const isLoggedIn = useIsLoggedIn();

  if (!isSweetpassEnabled) {
    return <NotFoundView />;
  }

  if (!isLoggedIn) {
    return <SignedOutView redirectTo="/rewards/sweetpass-checkout" />;
  }

  return <SweetpassCheckout />;
};
